import { render, staticRenderFns } from "./MMFDimSearch.vue?vue&type=template&id=5357e110&scoped=true&"
import script from "./MMFDimSearch.vue?vue&type=script&lang=js&"
export * from "./MMFDimSearch.vue?vue&type=script&lang=js&"
import style0 from "./MMFDimSearch.vue?vue&type=style&index=0&id=5357e110&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5357e110",
  null
  
)

export default component.exports